import { RouterProvider } from "react-router-dom";
import { AppProviders } from "@/app/providers/AppProviders";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { router } from "@/app/routes/router";

export function App() {
  return (
    <ErrorBoundary>
      <AppProviders>
        {/* Inner boundary keeps Session/Auth mounted for most route crashes. */}
        <ErrorBoundary>
          <div className="nbs-ui-root">
            <RouterProvider router={router} />
          </div>
        </ErrorBoundary>
      </AppProviders>
    </ErrorBoundary>
  );
}
